import client from './client';

const API_URL = '/api/worksheets';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export const fetchWorksheets = async (filters = {}) => {
    try {
        const params = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, value);
            }
        });
        const query = params.toString();
        const url = query ? `${API_URL}?${query}` : API_URL;
        const response = await client.get(url, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error fetching worksheets:', error);
        throw error;
    }
};

export const fetchWorksheetById = async (id) => {
    try {
        const response = await client.get(`${API_URL}/${id}`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error fetching worksheet ${id}:`, error);
        throw error;
    }
};

export const createWorksheet = async (data) => {
    try {
        const response = await client.post(API_URL, data, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error creating worksheet:', error);
        throw error;
    }
};

export const generateWorksheet = async (params) => {
    try {
        const response = await client.post(`${API_URL}/generate`, params, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error generating worksheet:', error);
        throw error;
    }
};

export const updateWorksheet = async (id, data) => {
    try {
        const response = await client.patch(`${API_URL}/${id}`, data, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error updating worksheet ${id}:`, error);
        throw error;
    }
};

export const deleteWorksheet = async (id) => {
    try {
        const response = await client.delete(`${API_URL}/${id}`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error deleting worksheet ${id}:`, error);
        throw error;
    }
};

export const scheduleWorksheet = async (id, scheduledDate) => {
    try {
        const response = await client.patch(`${API_URL}/${id}`, { scheduledDate }, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error scheduling worksheet ${id}:`, error);
        throw error;
    }
};

export const fetchCalendarWorksheets = async (start, end) => {
    try {
        const response = await client.get(`${API_URL}/calendar`, {
            params: { start, end },
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching calendar worksheets:', error);
        throw error;
    }
};

export const fetchDraftWorksheets = async () => {
    try {
        const response = await client.get(`${API_URL}/drafts`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error fetching draft worksheets:', error);
        throw error;
    }
};

export const addQuestion = async (worksheetId, data) => {
    try {
        const response = await client.post(`${API_URL}/${worksheetId}/questions`, data, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error adding question to worksheet ${worksheetId}:`, error);
        throw error;
    }
};

export const updateQuestion = async (worksheetId, questionId, data) => {
    try {
        const response = await client.patch(`${API_URL}/${worksheetId}/questions/${questionId}`, data, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error updating question ${questionId}:`, error);
        throw error;
    }
};

export const deleteQuestion = async (worksheetId, questionId) => {
    try {
        const response = await client.delete(`${API_URL}/${worksheetId}/questions/${questionId}`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error deleting question ${questionId}:`, error);
        throw error;
    }
};

export const reorderQuestions = async (worksheetId, questionIds) => {
    try {
        const response = await client.put(`${API_URL}/${worksheetId}/questions/reorder`, { questionIds }, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error reordering questions for worksheet ${worksheetId}:`, error);
        throw error;
    }
};

export const addQuestionStandard = async (worksheetId, questionId, standardId) => {
    try {
        const response = await client.post(`${API_URL}/${worksheetId}/questions/${questionId}/standards`, { standardId }, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error adding standard to question ${questionId}:`, error);
        throw error;
    }
};

export const removeQuestionStandard = async (worksheetId, questionId, standardId) => {
    try {
        const response = await client.delete(`${API_URL}/${worksheetId}/questions/${questionId}/standards/${standardId}`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error removing standard from question ${questionId}:`, error);
        throw error;
    }
};

export const fetchPrintData = async (id, includeKey = false) => {
    try {
        const params = includeKey ? { key: 'true' } : {};
        const response = await client.get(`${API_URL}/${id}/print`, {
            params,
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching print data for worksheet ${id}:`, error);
        throw error;
    }
};
